export const moneyStringFormat = (price: string) => {
    return Math.floor(Number(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const moneyStringFormatByNumber = (price: number) => {
    return Math.floor(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}